import React from 'react';
import styled from 'styled-components';

const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  transition: background-color 0.2s;
  position: relative;

  &:hover {
    background-color: #f5f5f5;
  }
`;

const NotificationIcon = styled.img`
  width: 24px;
  height: 24px;
`;

interface NotificationBellProps {
  onClick?: () => void;
  className?: string;
  hasNotification?: boolean; // 알림 여부
}

const NotificationBell: React.FC<NotificationBellProps> = ({ 
  onClick, 
  className, 
  hasNotification = false
}) => {
  const iconSrc = hasNotification ? '/common/bell_on.svg' : '/common/bell.svg';
  const altText = hasNotification ? '새 알림' : '알림';

  return (
    <IconButton onClick={onClick} className={className}>
      <NotificationIcon src={iconSrc} alt={altText} />
    </IconButton>
  );
};

export default NotificationBell;
